module.exports = __webpack_public_path__ + "static/media/26UNRWA23.b02d4831.jpg";